import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ShieldCheck } from '@phosphor-icons/react'
import { UserAvatar } from '@/components/common/UserAvatar'
import { StreakBadge } from '@/components/ui/StreakBadge'
import type { User } from '@/types/database.types'
import { formatFullName } from '@/utils/stringUtils'

interface DashboardHeaderProps {
  user: User | null
  getGreeting: () => string
  setShowInfoPopover: (type: 'streak' | 'score') => void
}

export function DashboardHeader({ user, getGreeting, setShowInfoPopover }: DashboardHeaderProps) {
  const navigate = useNavigate()
  const formattedName = formatFullName(user?.full_name) || 'Değerli Üye'

  return (
    <header className="flex items-center justify-between px-6 pt-[max(env(safe-area-inset-top),_1.25rem)] pb-4 sticky top-0 bg-[#FCFAF8]/80 backdrop-blur-md z-40">
      <div className="flex items-center gap-3.5 flex-1 min-w-0">
        <div className="relative cursor-pointer shrink-0" onClick={() => navigate('/profile')}>
          <div className="w-[58px] h-[58px] rounded-full border-[2.5px] border-[#D4AF37] p-[3px] flex items-center justify-center">
            <UserAvatar user={user} size="custom" className="w-full h-full" />
          </div>
        </div>
        <div className="flex flex-col justify-center flex-1 min-w-0 pr-2">
          <p className="text-[13px] text-[#CFA02E] font-bold tracking-wide mb-0.5">
            {getGreeting()}
          </p>
          <h2 className="text-[22px] font-sans font-extrabold leading-tight text-espresso tracking-tight truncate pb-0.5">
            {formattedName}
          </h2>
        </div>
      </div>
      
      <div className="flex items-center gap-2">
        {user && (user.current_streak || 0) > 0 ? (
          <div onClick={() => setShowInfoPopover('streak')} className="cursor-pointer">
            <StreakBadge streak={user.current_streak!} size="md" />
          </div>
        ) : (
          <div
            className="flex items-center gap-1.5 bg-[#EDF5F1] border border-[#DCE8E3] px-3 py-1.5 rounded-full cursor-pointer transition-transform active:scale-95"
            onClick={() => setShowInfoPopover('score')}
          >
            <ShieldCheck size={18} className="text-[#225240]" weight="fill" />
            <span className="text-[13px] font-bold text-[#1E503F] tracking-tight">
              {user?.reputation_score ?? 70}
            </span>
          </div>
        )}
      </div>
    </header>
  )
}
